import gql from 'graphql-tag';

const sectionOptionFragment = gql`
fragment SectionsOptionFragment on Section {
    name,
    id,
    places {
        id
        name
    }
}
`;

const employeeOptionFragment = gql`
fragment EmployeeOptionFragment on Employee {
    id,
    account {
        id
        firstName
        lastName
    }
}
`;



export const GET_FILTERS_OPTIONS = gql`
    query GetGenericFiltersOptions{
        sections {
            ...SectionsOptionFragment
        }
        employees {
            ...EmployeeOptionFragment
        }
    }
    ${sectionOptionFragment}
    ${employeeOptionFragment}
`;
